/**
 * description 融合编辑器服务
 * created by he.zhikai
 * created on 2017-12-28
 */
'use strict';
angular.module('editFusionEditorServiceModule', ['editFusionAddNavsModule', 'editFusionSwitchNavsModule'])
    .factory('editFusionEditorService', ['$modal', '$state', 'editingCenterService', '$validation', '$q', '$stateParams', '$timeout', 'trsHttpService', 'newMediaService', 'editingMediatype', 'myManuscriptService', 'messagePublishService', 'iWoService',
        function ($modal, $state, editingCenterService, $validation, $q, $stateParams, $timeout, trsHttpService, newMediaService, editingMediatype, myManuscriptService, messagePublishService, iWoService) {
            return {

                /**
                 * [doctype description] 添加渠道
                 * @param   {[type]}  doctype      [doctype description] 稿件类型
                 * @param   {[type]}  nowNavs      [nowNavs description] 已有渠道
                 * @param   {[type]}  sourceDocId  [sourceDocId description] iwoID
                 * @return  {[type]}               [return description]
                 */
                addNavs: function (doctype, nowNavs, sourceDocId) {
                    var defer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/iWo/fusionEditor/service/addNavs/addNavs_tpl.html',
                        windowClass: 'fusionAddNavs',
                        backdrop: false,
                        controller: 'editFusionAddNavsCtrl',
                        resolve: {
                            doctype: function () {
                                return doctype;
                            },
                            nowNavs: function () {
                                return nowNavs;
                            },
                            sourceDocId: function () {
                                return sourceDocId;
                            }
                        }
                    });
                    modalInstance.result.then(function (result) {
                        defer.resolve(result);
                    });
                    return defer.promise;
                },

                /**
                 * [switchNavs description] 切换渠道
                 * @param  {[type]} toNav    [description] 切换的渠道
                 * @param  {[type]} fromNavs [description] 已有的渠道
                 * @return {[type]}          [description]
                 */
                switchNavs: function (toNav, fromNavs) {
                    var defer = $q.defer();
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/iWo/fusionEditor/service/switchNavs/switchNavs_tpl.html',
                        windowClass: 'fusionSwitchNavs',
                        backdrop: false,
                        controller: 'editFusionSwitchNavsCtrl',
                        resolve: {
                            toNav: function () {
                                return toNav;
                            },
                            fromNavs: function () {
                                return fromNavs;
                            }
                        }
                    });
                    modalInstance.result.then(function (result) {
                        defer.resolve(result);
                    }, function () {
                        defer.reject();
                    });
                    return defer.promise;
                },

                /**
                 * [getDoctypeByRouter description] 根据路由名称获取稿件类型
                 * @param  {[type]} stateName [description] 路由名称
                 * @return {[type]}           [description]
                 */
                getDoctypeByRouter: function (stateName) {
                    var doctype = {
                        'fusionnews': '1',
                        'fusionatlas': '2',
                        'fusionlinkdoc': '4',

                        /* "fusionactivity": "5",
                        "fusiontopic": "6",*/ // 活动稿和话题稿
                        'fusionvideo': '7',
                        'fusionlive': '8'
                    };
                    return doctype[stateName];
                },

                /**
                 * [getDoctypeByRouter description] 根据路由名称获取稿件类型名称
                 * @param  {[type]} stateName [description] 路由名称
                 * @return {[type]}           [description]
                 */
                getDoctypeNameByRouter: function (stateName) {
                    var doctype = {
                        'fusionnews': '新闻',
                        'fusionatlas': '图集',
                        'fusionlinkdoc': '链接',
                        'fusiontopic': '专题', // 活动稿和话题稿
                        'fusionvideo': '视频',
                        'fusionlive': '直播'
                    };
                    return doctype[stateName];
                },

                /**
                 * [getNewsRouterByMediatype description] 根据渠道类型获取各渠道稿件路由
                 * @param  {[type]} mediatype [description] 渠道类型
                 * @param {[type]} [doctype] [description] 稿件类型
                 * @return {[type]}           [description]
                 */
                getRouterByMediatype: function (mediatype, doctype) {
                    var routerName = {
                        '0': { // iwo
                            '1': 'iwonews',
                            '2': 'iwoatlas',
                            '4': 'iwolinkdoc',
                            '7': 'iwovideo'
                        },
                        '1': { // 客户端
                            '1': 'appnews',
                            '2': 'appatlas',
                            '3': 'appsubject',
                            '4': 'appwebsite',
                            '5': 'appactivity',
                            '6': 'apptopic',
                            '7': 'appvideo',
                            '8': 'applive'
                        },
                        '2': { // 网站
                            '1': 'websitenews',
                            '2': 'websiteatlas',
                            '3': 'websitesubject',
                            '4': 'websitelinkdoc',
                            '7': 'websitevideo'
                        },
                        '3': { // 报纸
                            '1': 'newspapertext',
                            '2': 'newspaperpic'
                        },
                        '4': { // 微信
                            '1': 'wxeditpage'
                        },
                        '5': { // 微博
                            '1': 'wbeditpage',
                            '7': 'wbeditpage'
                        },
                        '17': { // 抖音
                            '7': 'trillnews' // 视频稿
                        },
                        '18': { // 百家号
                            '1': 'baijiahaonews',
                            '2': 'baijiahaoatlas',
                            '7': 'baijiahaovideo' // 视频稿
                        },
                        '19': { // 企鹅号
                            '1': 'qiehaonews',
                            '2': 'qiehaoatlas',
                            '7': 'qiehaovideo' // 视频稿
                        },
                        '20': { // 头条号
                            '1': 'toutiaohaonews',
                            '7': 'toutiaohaovideo',
                        }
                    };
                    return !!routerName[mediatype] ? routerName[mediatype][doctype] : '';
                },

                /**
                 * [getIwoListByDoctype description] 根据稿件类型获取我的虚拟稿件的保存参数
                 * @param  {[type]} doctype [description] 稿件类型
                 * @param {[type]} [iwoplatform] [description] iwo平台
                 * @return {[type]}         [description]
                 */
                getIwoListByDoctype: function (doctype, iwoplatform) {
                    var iwoList = {
                        '5': {
                            '0': {
                                serviceid: 'mlf_myrelease',
                                methodname: 'savePersonalActivityDoc',
                                MetaDataId: '',
                                HTMLCONTENT: '',
                                TITLE: '',
                                DOCWORDSCOUNT: ''
                            },
                            '1': {
                                serviceid: 'mlf_myrelease',
                                methodname: 'saveReceivedActivityDoc',
                                MetaDataId: '',
                                HTMLCONTENT: '',
                                TITLE: '',
                                DOCWORDSCOUNT: ''
                            }
                        },
                        '6': {
                            '0': {
                                serviceid: 'mlf_myrelease',
                                methodname: 'savePersonalTopicDoc',
                                MetaDataId: '',
                                HTMLCONTENT: '',
                                TITLE: '',
                                DOCWORDSCOUNT: ''
                            },
                            '1': {
                                serviceid: 'mlf_myrelease',
                                methodname: 'saveReceivedTopicDoc',
                                MetaDataId: '',
                                HTMLCONTENT: '',
                                TITLE: '',
                                DOCWORDSCOUNT: ''
                            }
                        },
                        '7': {
                            '0': {
                                serviceid: 'mlf_myrelease',
                                methodname: 'savePersonalVideo',
                                MetaDataId: '',
                                HTMLCONTENT: '',
                                TITLE: ''
                            },
                            '1': {
                                serviceid: 'mlf_myrelease',
                                methodname: 'saveReceivedVideo',
                                MetaDataId: '',
                                HTMLCONTENT: '',
                                TITLE: ''
                            }
                        },
                        '8': {
                            '0': {
                                serviceid: 'mlf_myrelease',
                                methodname: 'savePersonalLive',
                                MetaDataId: '',
                                URL: '',
                                TITLE: ''
                            },
                            '1': {
                                serviceid: 'mlf_myrelease',
                                methodname: 'saveReceivedLive',
                                MetaDataId: '',
                                URL: '',
                                TITLE: ''
                            }
                        }
                    };
                    return iwoList[doctype][iwoplatform];
                },

                sendmessage: iWoService.sendmessage,

                /**
                 * [getIwoPreviewByDoctype description] 根据稿件类型获取我的虚拟稿件的详情数据
                 * @param  {[type]} doctype [description] 稿件类型
                 * @return {[type]}         [description]
                 */
                getIwoPreviewByDoctype: function (doctype) {
                    var defer = $q.defer();
                    var iwoParams = {
                        '1': {
                            'serviceid': 'mlf_myrelease',
                            'methodname': 'getNewsDoc',
                            'MetaDataId': $stateParams.iwometadataid
                        },
                        '2': {
                            'serviceid': 'mlf_myrelease',
                            'methodname': 'getPicsDoc',
                            'MetaDataId': $stateParams.iwometadataid
                        },
                        '4': {
                            'serviceid': 'mlf_myrelease',
                            'methodname': 'getLinkDoc',
                            'MetaDataId': $stateParams.iwometadataid
                        },
                        '7': {
                            'serviceid': 'mlf_myrelease',
                            'methodname': 'getVideoDoc',
                            'MetaDataId': $stateParams.iwometadataid
                        }
                    };
                    var params = iwoParams[doctype];
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        defer.resolve(data);
                    });
                    return defer.promise;
                },

                /**
                 * [scope description] 更新发稿单信息
                 * @param   {[type]}  scope  [scope description]
                 * @param   {[type]}  nav    [nav description]
                 * @return  {[type]}         [return description]
                 */
                updateFgd: function (scope, nav) {
                    nav.controller.$scope.status.nopayment = scope.data.status.nopayment;
                    nav.controller.$scope.list.FGD_EDITINFO = scope.data.list.FGD_EDITINFO;
                    nav.controller.$scope.list.FGD_AUTHINFO = scope.data.list.FGD_AUTHINFO;
                    nav.controller.$scope.list.ISNOPAYMENT = scope.data.list.ISNOPAYMENT;
                    nav.controller.$scope.list.DOCGENRE = scope.data.list.DOCGENRE;
                },

                /**
                 * [scope description] 更新原创信息
                 * @param   {[type]}  scope         [scope description] 当前控制器的作用域
                 * @param   {[type]}  nav           [nav description]
                 * @param   {[type]}  noNdeeOrigin  [noNdeeOrigin description]
                 * @return  {[type]}                [return description]
                 */
                updateOriginal: function (scope, nav, noNdeeOrigin) {
                    if (!noNdeeOrigin) {
                        nav.controller.$scope.list.ORIGINAL = scope.data.list.ORIGINAL;
                        nav.controller.$scope.data.originType = scope.data.data.originType;
                    }
                    nav.controller.$scope.list.SPECIALDOC = scope.data.list.SPECIALDOC;
                    nav.controller.$scope.list.NewDocSourceName = scope.data.list.NewDocSourceName;
                    // nav.controller.$scope.list.NEWSSOURCES = scope.data.list.NEWSSOURCES;
                    nav.controller.$scope.data.specialDoc = scope.data.data.specialDoc;
                },

                /**
                 * [formValidator description] 主动触发表单校验
                 * @param  {[type]} scope   [description]
                 * @param  {[type]} $element [description]
                 * @return {[type]}          [description]
                 */
                formValidator: function (scope, $element) {
                    var form;
                    for (var i in scope) {
                        var obj = scope[i];
                        if (!obj) {continue;}
                        if (angular.isDefined(obj.$$parentForm)) {
                            form = obj;
                            break;
                        }
                    }
                    $timeout(function () {
                        $validation.validate(form).success(function () { }).error(function () {
                            editingCenterService.checkSaveError(form, $element, scope); // 定位输入错的表单位置
                        });
                    });
                },

                /**
                 * [departmentSubmit description] 部门提交
                 * @param   {[object]}  scope  [scope description] 当前页面角对象
                 * @param   {[string]}  title  [title description] 标题
                 * @return  {[type]}           [return description]
                 */
                departmentSubmit: function (scope, title) {
                    let thePlatform = ['person', 'receive'];
                    scope.iwoData = [{
                        'CHNLDOCID': $state.params.iwochnldocid,
                        'METADATAID': $state.params.iwometadataid,
                        'DOCTYPEID': this.getDoctypeByRouter($state.current.name),
                        'TITLE': title || scope.data.navs[0].list.TITLE,
                        'DOCTYPE': this.getDoctypeNameByRouter($state.current.name),
                        'DEPARTDOCRELID': $state.params.departdocrelid
                    }];
                    newMediaService.iwoDepartSubmit(scope, $state.params.departdocrelid ? 'manustransmit' : thePlatform[$state.params.iwoplatform]);
                },

                /**
                 * [share description] 共享
                 * @param  {[type]}  scope   [scope description] 当前控制器对象
                 * @return  {[type]}   [return description]
                 */
                share: function(scope) {
                    newMediaService.iwoShare(scope).then(function(shareObj) {
                        messagePublishService.publish('doEditPageOperation', iWoService.packageShareParams(shareObj));
                    });
                },

                /**
                 * [copyManuscript description]
                 * @param   {[type]}  scope     [scope description]
                 * @param   {[type]}  result    [result description]
                 * @param   {[type]}  copyInfo  [copyList description]
                 * @return  {[type]}            [return description]
                 */
                copyManuscript: function(scope, result, copyInfo){
                    let selecteMediatype = scope.data.selectedNav.MEDIATYPE * 1;
                    if (angular.isDefined(result)) {
                        let restultMediaType = result.MEDIATYPE * 1;
                        if (selecteMediatype === editingMediatype.weixin) {
                            scope.data.selectedNav.controller.$scope.list.AUTHOR = (restultMediaType === editingMediatype.website || restultMediaType === editingMediatype.newspaper || restultMediaType === editingMediatype.weixin) ? copyInfo.copyList.AUTHOR : copyInfo.copyList.SIGNATUREAUTHOR;
                            scope.data.selectedNav.controller.$scope.list.ABSTRACT = copyInfo.copyList.ABSTRACT;
                            scope.data.selectedNav.controller.$scope.list.REMARKS = copyInfo.copyList.REMARKS;
                            scope.data.selectedNav.controller.$scope.data.KEYWORDS = copyInfo.copyData.KEYWORDS;
                        }
                        // 如果复制到报纸，则去除正文中的音频和视频；将基础稿的属性信息初始化到其他渠道
                        if (selecteMediatype === editingMediatype.newspaper) {
                            var dom = document.createElement('div');
                            dom.innerHTML = result.list.HTMLCONTENT;
                            $(dom).find('img[audioid]').remove();
                            $(dom).find('img[videoid]').remove();
                            scope.data.selectedNav.controller.$scope.list.AUTHOR = (restultMediaType === editingMediatype.website || restultMediaType === editingMediatype.newspaper || restultMediaType === editingMediatype.weixin) ? copyInfo.copyList.AUTHOR : copyInfo.copyList.SIGNATUREAUTHOR;
                            scope.data.selectedNav.controller.$scope.list.REMARKS = copyInfo.copyList.REMARKS;
                            scope.data.selectedNav.controller.$scope.list.SUBTITLE = copyInfo.copyList.SUBTITLE; // 文章副题，网站和报纸有
                            scope.data.selectedNav.controller.$scope.list.JTITLE = copyInfo.copyList.LEADTITLE; // 文章肩题，网站和报纸有，但字段不同，需要特殊转换
                        } else if (selecteMediatype === editingMediatype.website) {
                            scope.data.selectedNav.controller.$scope.list.AUTHOR = (restultMediaType === editingMediatype.website || restultMediaType === editingMediatype.newspaper || restultMediaType === editingMediatype.weixin) ? copyInfo.copyList.AUTHOR : copyInfo.copyList.SIGNATUREAUTHOR;
                            scope.data.selectedNav.controller.$scope.data.KEYWORDS = copyInfo.copyData.KEYWORDS;
                            scope.data.selectedNav.controller.$scope.list.ABSTRACT = copyInfo.copyList.ABSTRACT;
                            scope.data.selectedNav.controller.$scope.list.REMARKS = copyInfo.copyList.REMARKS;
                            scope.data.selectedNav.controller.$scope.list.SUBTITLE = copyInfo.copyList.SUBTITLE; // 文章副题，网站和报纸有
                            scope.data.selectedNav.controller.$scope.list.LEADTITLE = copyInfo.copyList.JTITLE; // 文章肩题，网站和报纸有，但字段不同，需要特殊转换
                        } else if (selecteMediatype === editingMediatype.app) {
                            scope.data.selectedNav.controller.$scope.list.SIGNATUREAUTHOR = (restultMediaType === editingMediatype.website || restultMediaType === editingMediatype.newspaper || restultMediaType === editingMediatype.weixin) ? copyInfo.copyList.AUTHOR : copyInfo.copyList.SIGNATUREAUTHOR;
                            scope.data.selectedNav.controller.$scope.data.KEYWORDS = copyInfo.copyData.KEYWORDS;
                            scope.data.selectedNav.controller.$scope.list.ABSTRACT = copyInfo.copyList.ABSTRACT;
                            scope.data.selectedNav.controller.$scope.list.REMARKS = copyInfo.copyList.REMARKS;
                        }
                        scope.data.selectedNav.controller.$scope.list.CONTENT = result.list.CONTENT;
                        // 新建融合编辑稿件时将选中的报题对象带过去
                        scope.data.selectedNav.controller.$scope.data.selectedReport = copyInfo.copyData.selectedReport;
                        scope.data.selectedNav.controller.$scope.data.selectedTask = copyInfo.copyData.selectedTask;
                        // 将标题等字段复制过来，但微博渠道不需要复制这些字段
                        if (selecteMediatype !== editingMediatype.weibo) {
                            scope.data.selectedNav.controller.$scope.list.TITLE = result.list.TITLE;
                            scope.data.selectedNav.controller.$scope.list.HTMLCONTENT = result.list.HTMLCONTENT;
                            scope.data.selectedNav.controller.$scope.list.REMARKS = copyInfo.copyList.REMARKS;
                            // 将“是否能勾选原创稿”同步过来，取稿的稿件打原创标记
                            scope.data.selectedNav.controller.$scope.list.CANORIGINAL = result.list.CANORIGINAL;
                        }
                        //  如果是微博的话 需要去掉图说
                        if (selecteMediatype === editingMediatype.weibo) {
                            var imgDom = document.createElement('div');
                            imgDom.innerHTML = result.list.HTMLCONTENT;
                            $(imgDom).find('p[class="imagenote"]').remove();
                            if (imgDom.innerText.trim().length) {
                                scope.data.selectedNav.controller.$scope.list.CONTENT = imgDom.innerText;
                            } else {
                                scope.data.selectedNav.controller.$scope.list.CONTENT = result.list.TITLE;
                            }
                            scope.data.selectedNav.controller.$scope.list.REMARKS = copyInfo.copyList.REMARKS;
                        }
                        if (result.MEDIATYPE * 1 === editingMediatype.weibo) {
                            scope.data.selectedNav.controller.$scope.list.HTMLCONTENT = result.list.HTMLCONTENT.replace(/\n/g, '<br/>').replace(/ /g, '&nbsp;');
                        }
                        if (copyInfo.copyList.DOC_PICTURELIST && copyInfo.copyList.DOC_PICTURELIST.length){
                            if (copyInfo.copyList.PICTURELIST){ // 由于新媒体渠道的图片字段与原有渠道不同，特殊处理一下，否则DOC_PICTURELIST均为基础稿的值
                                copyInfo.copyList.DOC_PICTURELIST = copyInfo.copyList.PICTURELIST;
                            }
                            // 复制图集
                            for (var i = 0; i < copyInfo.copyList.DOC_PICTURELIST.length; i++) {
                                copyInfo.copyList.DOC_PICTURELIST[i].APPENDIXID = '0';
                            }
                            scope.data.selectedNav.controller.$scope.list.DOC_PICTURELIST = copyInfo.copyList.DOC_PICTURELIST;
                            if (scope.data.selectedNav.controller.$scope.list.PICTURELIST) { // 解决百家号、企鹅号对应图片字段不同的问题
                                scope.data.selectedNav.controller.$scope.list.PICTURELIST = copyInfo.copyList.DOC_PICTURELIST;
                            }
                        }
                        // 复制视频
                        if (copyInfo.copyAudioVideoidsArray && copyInfo.copyAudioVideoidsArray.length) {
                            scope.data.selectedNav.controller.$scope.data.videoId = copyInfo.copyData.videoId;
                            scope.data.selectedNav.controller.$scope.status.audioVideoidsArray = copyInfo.copyAudioVideoidsArray;
                            scope.data.selectedNav.controller.$scope.list.VIDEOREL = copyInfo.copyAudioVideoidsArray;
                            scope.data.selectedNav.controller.$scope.uploader = angular.copy(result.controller.$scope.uploader); // 视频状态传递过去
                        }
                        // 复制稿件背景
                        if (copyInfo.copyList.BGAPPENDIX && copyInfo.copyList.BGAPPENDIX.length){
                            scope.data.selectedNav.controller.$scope.list.BGAPPENDIX = copyInfo.copyList.BGAPPENDIX;
                        }
                    }
                }
            };
        }
    ]);
